import { Lesson } from '../../main/types/asset/lesson.types.ts';
import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';

export const mapPreviousLesson = (lessonKey: number): Lesson | null => {
  if (lessonKey === 0) {
    return null;
  }

  const lessonsUtil = getLessonsUtil();
  const previousLesson = lessonsUtil.getLesson({ lesson: lessonKey - 1 });

  return previousLesson ?? null;
};
